import { computed, watch } from 'vue'
import { useUserStore } from '@/stores'

export function useUser() {
  /** 送付先フォームのストア */
  const user = useUserStore()

  watch(user.form, () => {
    // 送付先フォームの中身が変更されたらLocalStorageと同期する
    user.store()
  })

  /** `user.form` のショートハンド */
  const form = computed(() => user.form)

  /** `user.error` のショートハンド */
  const error = computed(() => user.error)

  return { user, form, error }
}
